import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor(
    private localStorageService: LocalStorageService
  ) { }

  getURL(rutaMicroservicio: string): string {

    let urlBaseApi: string = "";
    let apiVip: string = "";

    let urlFinal: string = "";

    if (this.localStorageService.getIsVip) {
      urlBaseApi = environment.VIP_URL_BASE_API;  // "https://api.dev.latam.equifax.com/datamaintenance"
                                                  // "https://uat-datamaintenance.latam.equifax.com/facade-vip"
      // this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      apiVip = '/vip';
      urlFinal = `${urlBaseApi}${apiVip}${rutaMicroservicio}`;
    } else {
      urlBaseApi = this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
      apiVip = '/api';
      urlFinal = `${urlBaseApi}${rutaMicroservicio}${apiVip}`;
    }

    if (urlBaseApi && apiVip) {
      return urlFinal;
    } else {
      console.log("RETORNO NOOK");
      return `${rutaMicroservicio}${apiVip}`;
    }
  }
}
